<script setup>
import { computed, ref } from 'vue'
import { usePage, router } from '@inertiajs/vue3'
import OverviewPendingItem from './OverviewPendingItem.vue'
import OverviewCountPill from './OverviewCountPill.vue'

const page    = usePage()
const rawData = computed(() => page.props.__neo_main?.__data)

// Local list so we can remove items optimistically
const queue = ref([])
const loaded = ref(false)

// Sync from page props once
import { watch, onMounted } from 'vue'
onMounted(() => {
    if (rawData.value?.upcoming) {
        queue.value = (rawData.value.upcoming ?? []).filter(r => r.status === 'pending')
        loaded.value = true
    }
})

// Reservations with pending state (from upcoming list)
const pendingItems = computed(() => queue.value)

function accept(id) {
    queue.value = queue.value.filter(r => r.id !== id)
    router.patch(route('app.reservations.notify', { reservation: id }), { state: 'accepted' }, { preserveState: true })
}

function reject(id) {
    queue.value = queue.value.filter(r => r.id !== id)
    router.patch(route('app.reservations.notify', { reservation: id }), { state: 'rejected' }, { preserveState: true })
}
</script>

<template>
    <div>
        <div v-if="!pendingItems.length" class="text-[13px] text-gray-400 dark:text-neutral-500 py-3">
            {{ $t('dashboard.pending_done') }}
        </div>
        <OverviewPendingItem
            v-for="item in pendingItems"
            :key="item.id"
            :reservation="item"
            @accept="accept"
            @reject="reject"
        />
    </div>
</template>
